<div class="markers-group" (click)="markerClick.emit(start)">
  @for (item of previewUrl | slice: 0:2; track item) {
  <div class="marker">
    @if (item) {
    <div
      class="marker-img-holder"
      [class.unavailable]="!isAvailable"
      [style.background-image]="'url(' + addResize(item) + ')'"
    ></div>
    }
  </div>
  }
</div>
